import { parseJwt } from 'shared/utils';
import { useLocalStorage } from './useLocalStorage';
export var localStorageTokenKey = 'access_token';
export var useToken = function () {
    var token = useLocalStorage(localStorageTokenKey, null, false)[0];
    return parseJwt(token || '');
};
